import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get(key) {
  var tmp;
  if (equals(this.r3(), key)) {
    tmp = isInterface(this, Element()) ? this : THROW_CCE();
  } else {
    tmp = null;
  }
  return tmp;
}
function fold(initial, operation) {
  return operation(initial, this);
}
function minusKey(key) {
  return equals(this.r3(), key) ? EmptyExecutionContext_instance : this;
}
var ElementClass;
function Element() {
  if (ElementClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Element', VOID, VOID, [ExecutionContext()]);
    ElementClass = $;
  }
  return ElementClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.e42_1 = EmptyExecutionContext_instance;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function ExecutionContext$plus$lambda(acc, element) {
  var removed = acc.d46(element.r3());
  var tmp;
  if (removed === EmptyExecutionContext_instance) {
    tmp = element;
  } else {
    tmp = new (CombinedExecutionContext())(removed, element);
  }
  return tmp;
}
function plus(context) {
  var tmp;
  if (context === EmptyExecutionContext_instance) {
    tmp = this;
  } else {
    tmp = context.c46(this, ExecutionContext$plus$lambda);
  }
  return tmp;
}
var ExecutionContextClass;
function ExecutionContext() {
  if (ExecutionContextClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ExecutionContext');
    ExecutionContextClass = $;
  }
  return ExecutionContextClass;
}
var EmptyExecutionContextClass;
function EmptyExecutionContext() {
  if (EmptyExecutionContextClass === VOID) {
    class $ {
      b46(key) {
        return null;
      }
      c46(initial, operation) {
        return initial;
      }
      s43(context) {
        return context;
      }
      d46(key) {
        return this;
      }
    }
    initMetadataForObject($, 'EmptyExecutionContext', VOID, VOID, [ExecutionContext()]);
    EmptyExecutionContextClass = $;
  }
  return EmptyExecutionContextClass;
}
var EmptyExecutionContext_instance;
function EmptyExecutionContext_getInstance() {
  return EmptyExecutionContext_instance;
}
var CombinedExecutionContextClass;
function CombinedExecutionContext() {
  if (CombinedExecutionContextClass === VOID) {
    class $ {
      constructor(left, element) {
        this.q46_1 = left;
        this.r46_1 = element;
      }
      b46(key) {
        var cur = this;
        while (true) {
          var tmp0_safe_receiver = cur.r46_1.b46(key);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            return tmp0_safe_receiver;
          }
          var next = cur.q46_1;
          if (next instanceof CombinedExecutionContext()) {
            cur = next;
          } else {
            return next.b46(key);
          }
        }
      }
      c46(initial, operation) {
        return operation(this.q46_1.c46(initial, operation), this.r46_1);
      }
      d46(key) {
        if (this.r46_1.b46(key) == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return this.q46_1;
        }
        var newLeft = this.q46_1.d46(key);
        return newLeft === this.q46_1 ? this : newLeft === EmptyExecutionContext_instance ? this.r46_1 : new (CombinedExecutionContext())(newLeft, this.r46_1);
      }
    }
    protoOf($).s43 = plus;
    initMetadataForClass($, 'CombinedExecutionContext', VOID, VOID, [ExecutionContext()]);
    CombinedExecutionContextClass = $;
  }
  return CombinedExecutionContextClass;
}
//region block: init
EmptyExecutionContext_instance = new (EmptyExecutionContext())();
//endregion
//region block: exports
export {
  fold as fold2eqrvrnjdby59,
  get as get250w32d89zql9,
  minusKey as minusKeyaa3vrrv8zn1t,
  Element as Elementfqwhwe88j543,
  plus as plus3bjhh80fy28if,
  Companion_getInstance as Companion_getInstance29ub64y89bvyi,
};
//endregion

//# sourceMappingURL=ExecutionContext.mjs.map
